import mobileAppPreview from '../components/mobile-app-preview';
import modal from '../components/modal';
import swiperHorizontal from '../components/swiper-horizontal';
import swiperVertical from '../components/swiper-vertical';
import testimonialSlider from '../components/testimonial-slider';

export default {
  init() {
    // JavaScript to be fired on all pages
    mobileAppPreview()
    modal();
    swiperHorizontal();
    swiperVertical();
    testimonialSlider();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
